// removed by extract-text-webpack-plugin
module.exports = {"full-page-load":"fullPageLoader-module__full-page-load___2Wyj8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/fullPageLoader.module.scss
// module id = 287
// module chunks = 1